import { createSelector, createFeatureSelector } from '@ngrx/store';

import {
  ActiveIngredientSetting,
  ActiveIngredientsSettingState,
} from '../../activeingredientsetting.model';
import { adapter } from '../reducers/activeingredientsetting.reducer';

const {
  // selectIds,
  selectEntities,
  selectAll,
  // selectTotal
} = adapter.getSelectors();

export const getActiveIngredientSettingsState =
  createFeatureSelector<ActiveIngredientsSettingState>('activeingredientsettings');

export const getActiveIngredientSettingsEntities = createSelector(
  getActiveIngredientSettingsState,
  selectEntities,
);

export const getActiveIngredientSettings = createSelector(
  getActiveIngredientSettingsState,
  selectAll,
);

export const getActiveIngredientSetting = createSelector(
  getActiveIngredientSettingsEntities,
  (activeIngredientSetting: { [key: string]: ActiveIngredientSetting }, props: { id: string }) =>
    activeIngredientSetting[props.id],
);
